"use strict";
exports.__esModule = true;
require("../_color/Theme_color_yandex-default.css");
require("../_size/Theme_size_default.css");
require("../_capacity/Theme_capacity_default.css");
require("../_space/Theme_space_default.css");
require("../_cosmetic/Theme_cosmetic_default.css");
exports.theme = {
    color: 'yandex-default',
    size: 'default',
    capacity: 'default',
    space: 'default',
    cosmetic: 'default'
};
